import apiClient from './client';

/** 审计事件查询（只读）API 客户端。 */

export interface AuditEvent {
  id: string;
  action: string;
  entity_type: string;
  entity_id: string | null;
  actor_id: string | null;
  tenant_id: string | null;
  details: Record<string, unknown> | null;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string;
}

export interface AuditEventPage {
  items: AuditEvent[];
  total: number;
}

export async function listAuditEvents(limit = 50): Promise<AuditEventPage> {
  const res = await apiClient.get('/audit/events', { params: { limit } });
  return res.data;
}
